export default "__VITE_ASSET__CbAx$4Xd__"